<template>
	<sacleBox>
		<div class="appconten">
			<div class="usertitles">
				<img class="userimg" src="./../../assets/usertoptitle.png" alt="" srcset="" />
				<p class="userback" @click="callbackgr()">
					<img style="transform: rotateZ(90deg);margin-right: 20px;" src="./../../assets/backuser.svg" alt="" srcset="" />
					<span>返回</span>
				</p>
				<p class="usertiefonts">学员实训技能画像</p>
			</div>
			<div class="usermessages">
				<div class="usermitem">
					<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
					<div class="usermessagelist">
						<div class="usermesbox">
							<img v-if="usersa.ui_photoPath" style="width: 60px;height: 60px;border-radius: 50%;" :src="usersa.ui_photoPath" alt="" srcset="" />
							<img v-else style="width: 60px;height: 60px;border-radius: 50%;" src="./../../images/header.png" alt="" srcset="" />
							<div class="usermename" style="margin-left: 10px;">
								<p style="margin-bottom: 10px;font-weight: 600;font-size: 1.1rem;">{{ usersa.ui_realName }}</p>
								<p>
									<span style="display: block;font-size: 16px;">学号：</span>
									<span>{{ usersa.ui_joyNumber }}</span>
								</p>
							</div>
						</div>
						<div class="usermesbox" style="background-color: #13D0B2;height: 28%;">
							<div class="usermename">
								<p style="display: flex;">
									<span style="display: block;font-size: 1rem;">所属专业：</span>
									<span style="font-size: 1rem;" :title="usersa.pro_name">{{ usersa.pro_name ?? '' }}</span>
								</p>
								<div>
									<p style="font-size: 16px;">所属班级：</p>
									<p style="word-break:break-all;font-size: 14px;" :title="usersa.cla_name">{{ usersa.cla_name ?? '' }}</p>
								</div>
							</div>
						</div>
						<div class="usermesbox" style="height: 28%;background-color: #F6A645;justify-content: center;">
							<span class="el-icon-time" style="font-size: 4rem;color: #fff;"></span>
							<div class="usermename" style="margin-left: 0.8rem;">
								<p style="margin-bottom: 0.4rem;">累计实训时长</p>
								<p>
									<span style="font-size: 1.3rem;color: #0000FF;font-weight: 600;">{{ timeLength }}</span>
									<span style="font-size: 1rem;margin-left: 0.4rem;">小时</span>
								</p>
							</div>
						</div>
					</div>
					<img class="borderbottom" src="./../../assets/borderbottom.png" alt="" />
				</div>

				<div class="usermitem" style="width: 37%;margin-left: 20px;">
					<div class="usermitems" style="height: 30%;">
						<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
						<div class="usermitestect">
							<!-- <div style="width: 34%;margin-right: 12px;" :title="showtitle(proguid, 3)">
								<el-select @change="changezyselect" v-model="proguid" placeholder="请选择专业">
									<el-option v-for="item in profession" :key="item.pro_guid" :label="item.pro_name" :value="item.pro_guid"></el-option>
								</el-select>
							</div> -->
							<div style="width: 50%;margin-right: 12px;" :title="showtitle(value, 0)">
								<el-select @change="changeselect" v-model="value" placeholder="请选择班级">
									<el-option v-for="item in options" :key="item.cla_guid" :label="item.cla_name" :value="item.cla_guid"></el-option>
								</el-select>
							</div>
							<div style="width: 40%;margin-right: 12px;" :title="showtitle(siguidvalue, 1)">
								<el-select v-model="siguidvalue" placeholder="选择学员" @change="selectuser()">
									<el-option v-for="item in options1" :key="item.ui_guid" :label="item.ui_realName" :value="item.ui_guid"></el-option>
								</el-select>
							</div>
						</div>
						<img class="borderbottom" style="height: 90px;bottom:30px" src="./../../assets/borderbottom.png" alt="" />
					</div>
					<!-- 实训能力项目 -->
					<div class="usermitems" style="height: 70%;">
						<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
						<div style="padding: 1rem;width: 100%;height: 100%;" id="usermitemchats"></div>
						<img class="borderbottom" src="./../../assets/borderbottom.png" alt="" />
					</div>
				</div>

				<div class="usermitem" style="width: 45%;margin-left: 2%;">
					<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
					<div style="padding: 1rem;width: 100%;height: 100%;">
						<p style="color: #fff;font-size: 1.4rem;letter-spacing: 1px;margin-left: 2rem;">实训数据模型</p>
						<div class="trainsb monitor">
							<ul style="height: 55px;border-bottom: 2px solid #fff;">
								<li>
									<p style="background-color: transparent;width: 90px;justify-content: flex-start;">排名</p>
									<p style="width:40%;">能力项目</p>
									<p style="width:10%;">成绩</p>
									<p style="width:10%;">优秀</p>
									<p style="width:10%;">良好</p>
									<p style="width:10%;">一般</p>
									<p style="width:10%;">未掌握</p>
								</li>
							</ul>
							<div style="overflow-y: hidden;margin-top: 10px;">
								<vueSeamlessScroll v-if="Scrolllist.length > 0" :data="Scrolllist" class="seamless-warp" :class-option="classOption1">
									<ul>
										<li v-for="(item, index) in Scrolllist" :key="index">
											<div style="padding-left: 5px;background-color: transparent;width: 90px;text-align: center;">
												<p>{{ index + 1 }}</p>
											</div>
											<p style="text-align: left;width: 40%;">{{ item.projectName }}</p>
											<p style="width:10%;text-align: left;">{{ item.projectAST }}</p>
											<p style="width:10%;padding-left: 10px;">{{ item.projectBest }}</p>
											<p style="width:10%;padding-left: 10px;">{{ item.projectGood }}</p>
											<p style="width:10%;padding-left: 10px;">{{ item.projectGeneral }}</p>
											<p style="width:10%;padding-left: 10px;">{{ item.projectNoEvaluating }}</p>
										</li>
									</ul>
								</vueSeamlessScroll>
							</div>
						</div>
						<!-- <div class="paginationno" v-if="isdatastanum == 0">暂无实训数据</div> -->
					</div>

					<img class="borderbottom" src="./../../assets/borderbottom.png" alt="" />
				</div>
			</div>

			<div class="usermessages">
				<div class="usermitem" style="width: 33%;">
					<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
					<div style="padding: 1rem;width: 100%;height: 100%;" id="scores"></div>
					<img class="borderbottom" src="./../../assets/borderbottom.png" alt="" />
				</div>
				<div class="usermitem" style="width: 33%;margin: 0 20px;">
					<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
					<!-- <el-empty v-if="projectsta.length == 0" style="height: 100%;" description="暂无实训项目数据,请尽快完成实训"></el-empty> -->
					<div class="cilprogess">
						<div style="color: #fff;font-size: 1.4rem;letter-spacing: 1px;margin-left: 2rem;">实训任务完成度</div>
						<el-row :gutter="20" style="height: 90%;margin-top: 15px;">
							<el-col :span="12" style="height: 50%;flex-direction: column;display: flex;align-items: center;justify-content: center;">
								<el-progress
									type="circle"
									:width="100"
									:percentage="percentage1"
									:stroke-width="10"
									color="#029676"
									define-back-color="#002865"
									text-color="#01F8FF"
								></el-progress>
								<p>标准化作业</p>
							</el-col>
							<el-col :span="12" style="height: 50%;flex-direction: column;display: flex;align-items: center;justify-content: center;">
								<el-progress
									type="circle"
									:width="100"
									:percentage="percentage2"
									:stroke-width="10"
									color="#C45457"
									define-back-color="#002865"
									text-color="#01F8FF"
								></el-progress>
								<p>非正常行车</p>
							</el-col>
							<el-col :span="12" style="height: 50%;flex-direction: column;display: flex;align-items: center;justify-content: center;">
								<el-progress
									type="circle"
									:width="100"
									:percentage="percentage3"
									:stroke-width="10"
									color="#2988C5"
									define-back-color="#002865"
									text-color="#01F8FF"
								></el-progress>
								<p>应急救援</p>
							</el-col>
							<el-col :span="12" style="height: 50%;flex-direction: column;display: flex;align-items: center;justify-content: center;">
								<el-progress
									type="circle"
									:width="100"
									:percentage="percentage4"
									:stroke-width="10"
									color="#B27939"
									define-back-color="#002865"
									text-color="#01F8FF"
								></el-progress>
								<p>故障处理</p>
							</el-col>
						</el-row>
					</div>
					<img class="borderbottom" src="./../../assets/borderbottom.png" alt="" />
				</div>
				<div class="usermitem" style="width: 33%;">
					<img class="bordertop" src="./../../assets/bordertop.png" alt="" />
					<div style="padding: 1rem;width: 100%;height: 100%;" id="timercensus"></div>
					<img class="borderbottom" src="./../../assets/borderbottom.png" alt="" />
				</div>
			</div>
		</div>
	</sacleBox>
</template>

<script>
import AppOptions from '@/config/AppOptions.vue';
import {
	GetClassInfoList,
	GetStudentInfoList,
	GetStudentInfo,
	GetStudentTimeLengthApi, //  新学习时长
	GetStudentResultsDataListApi, // 新实训成绩
	TrainingTaskStatisticsApi, // 新实训成绩模拟驾驶
	GetMyComprehensiveSTAPi, // 新综合实训技能
	GetMyProjectSTANewApi, // 新项目分类统计
	GetMyTrainDataSTANewApi, // 新实训数据报表
	GetMyTrainDataSTANewCQApi, // 新实训数据报表模拟驾驶
	GetTaskComplianceApi, //达标度
	GetDatasyncApi //检测同步数据
} from '@/request/alllog.js';
import vueSeamlessScroll from 'vue-seamless-scroll';
import {
	GetzyProfList //专业列表
} from '@/request/api/mange/mange.js';
import sacleBox from '@/components/sacleBox.vue';

export default {
	data() {
		return {
			// 选择器
			options: [],
			value: '',
			siguidvalue: '',
			options1: [],
			dateacti: 0,
			Scrolllist: [],
			tableData: [
				{
					name: '理论知识',
					evaluation: 90,
					abilitynamee: '理论考核',
					abilitevaluation: 98,
					totole: 1,
					scuuss: 1,
					fine: '',
					sort: '',
					notmaster: '',
					notevaluated: ''
				},
				{
					name: '基本功能',
					evaluation: 85,
					abilitynamee: 'CTC软件基本操作',
					abilitevaluation: 85,
					totole: 46,
					scuuss: 33,
					fine: 4,
					sort: 3,
					notmaster: 3,
					notevaluated: 3
				},
				{
					name: '电务设备故障应急处置',
					evaluation: 32.11,
					abilitynamee: 'CTC软件基本操作',
					abilitevaluation: 85,
					totole: 46,
					scuuss: 33,
					fine: 4,
					sort: 3,
					notmaster: 3,
					notevaluated: 3
				},
				{
					name: '电务设备故障应急处置',
					evaluation: '',
					abilitynamee: 'CTC软件基本操作',
					abilitevaluation: 85,
					totole: 46,
					scuuss: 33,
					fine: 4,
					sort: 3,
					notmaster: 3,
					notevaluated: 3
				}
			],
			traintimer: [],
			trainfllist: [
				{
					value: 40,
					name: '基本技能',
					per: 20
				},
				{
					value: 38,
					name: '理论知识',
					per: 30
				},
				{
					value: 32,
					name: '自然灾害处置应急',
					per: 20
				},
				{
					value: 30,
					name: '公务应急故障处置设置',
					per: 10
				},
				{
					value: 28,
					name: '电务设备故障应急处置',
					per: 20
				}
			],
			scoreschars: [],
			ability: [],
			options4s: {},
			option3s: {},
			option1s: {},
			option2s: {},
			siguids: '',
			usersa: {},
			datenows: 'week',
			Comprehensive: [],
			projectsta: [],
			pageindex: 1,
			traindatastalist: [],
			traindatastaobj: {},
			keyname: [],
			traindatastalista: [],
			allindex: 0,
			isdatastanum: 0,
			projectstabname: [],
			projectstab: [],
			//
			addbiltysboxvontentwidth1: 0,
			addbiltysboxvontentwidth2: 0,
			titletrnodenumswidth: 0,
			projectsumalldom: 0,
			testuids: '',
			tesoptions: [],
			// 专业列表信息
			profession: [],
			proguid: '',
			percentage4: 0,
			percentage3: 0,
			percentage2: 0,
			percentage1: 0,
			lastNumber: 0,
			timera: null,
			builtylist: [50, 20, 60, 30, 20],
			timera1: null,
			timeLength: 0,
			isdatascheck: 0
		};
	},
	created() {
		AppOptions.appEmpty = true;
		this.siguids = this.$route.query.siguid;
	},
	beforeRouteEnter(to, from, next) {
		// 添加背景色 margin:0;padding:0是为了解决vue四周有白边的问题
		document.querySelector('body').setAttribute('style', 'margin:0;padding:0');
		next();
	},
	computed: {
		classOption1() {
			return {
				step: 0.2, // 数值越大速度滚动越快
				limitMoveNum: this.Scrolllist.length, // 开始无缝滚动的数据量 this.dataList.length
				hoverStop: true, // 是否开启鼠标悬停stop
				direction: 1, // 0向下 1向上 2向左 3向右
				openWatch: true, // 开启数据实时监控刷新dom
				singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
				singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
				waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
			};
		}
	},
	mounted() {
		document.title = '实训室管理平台';
		// chart 自适应
		this.changecharts();
		// 获取班级信息
		this.getclassinfo();
	},
	updated() {},
	methods: {
		generateRandomNumberGreaterThanLast() {
			let newNumber1;
			let newNumber2;
			let newNumber3;
			let newNumber4;

			newNumber1 = Math.ceil(this.fullClose(1, 100));
			newNumber2 = Math.ceil(this.fullClose(1, 100)); // 生成1到100之间的随机数
			newNumber3 = Math.ceil(this.fullClose(1, 100)); // 生成1到100之间的随机数
			newNumber4 = Math.ceil(this.fullClose(1, 100)); // 生成1到100之间的随机数
			// console.log(newNumber1, newNumber2, newNumber3, newNumber4, '生成随机数值');
			this.percentage4 = newNumber4;
			this.percentage3 = newNumber3;
			this.percentage2 = newNumber2;
			this.percentage1 = newNumber1;
		},
		//取得[n,m]范围随机数
		fullClose(n, m) {
			let result = Math.random() * (m + 1 - n) + n;
			while (result > m) {
				result = Math.random() * (m + 1 - n) + n;
			}
			return result;
		},
		// echarts 自适应
		changecharts() {
			// 实训任务完成度

			// 实训成绩信息
			let myCharts2 = this.$echarts.getInstanceByDom(document.getElementById('scores'));
			if (myCharts2 == null) {
				myCharts2 = this.$echarts.init(document.getElementById('scores'));
			}

			// 综合实训技能
			let myCharts1 = this.$echarts.getInstanceByDom(document.getElementById('usermitemchats'));
			if (myCharts1 == null) {
				myCharts1 = this.$echarts.init(document.getElementById('usermitemchats'));
			}

			// 实训时长统计
			let myCharts4 = this.$echarts.getInstanceByDom(document.getElementById('timercensus'));
			if (myCharts4 == null) {
				myCharts4 = this.$echarts.init(document.getElementById('timercensus'));
			}

			// 实训任务完成度
			this.setcensuschats();

			window.addEventListener('resize', function() {
				myCharts1.resize();
				myCharts2.resize();
				myCharts4.resize();
			});
		},
		taskscoces() {
			GetTaskComplianceApi({
				ui_guid: this.siguidvalue
			}).then(res => {
				// console.log(res, '任务大程度');
			});
		},

		// hover显示标题
		showtitle(val, nums) {
			// 显示title
			let idnames;
			if (nums == 0) {
				if (this.options.length > 0) {
					if (val) {
						idnames = this.options.filter(ite => ite.cla_guid == val);

						if (idnames.length > 0) {
							return idnames[0].cla_name;
						}
					}
				}
			} else if (nums == 1) {
				if (this.options1.length > 0) {
					if (val) {
						idnames = this.options1.filter(ite => ite.ui_guid == val);

						if (idnames.length > 0) {
							return idnames[0].ui_realName ?? '';
						}
					}
				}
			} else if (nums == 3) {
				if (this.profession.length > 0) {
					if (val) {
						idnames = this.profession.filter(ite => ite.pro_guid == val);
						// console.log(idnames, '专业名字');
						if (idnames.length > 0) {
							return idnames[0].pro_name ?? '';
						}
					}
				}
			}
			return '';
		},
		// 获取专业列表信息
		changezylist() {
			let siguid = this.$route.query.siguid;
			GetzyProfList(siguid).then(res => {
				// console.log('获取专业列表信息', res.data.data);
				this.profession = res.data.data;
				if (this.profession && this.profession.length > 0) {
					this.proguid = this.profession[0].proguid;
				}
			});
		},
		// 更改专业信息
		changezyselect() {},

		// 更改班级信息
		changeselect() {
			this.options1 = [];
			if (this.value == '') {
				this.siguidvalue = '';
			} else {
				this.getstudents(1);
			}
		},
		// 选择学员信息
		selectuser() {
			if (this.siguidvalue == '') {
				this.setcensuschats();

				this.isdatastanum = 0;
				this.scoreschars = [
					{
						date: '1',
						count: 0
					},
					{
						date: '1',
						count: 0
					},
					{
						date: '1',
						count: 0
					},
					{
						date: '1',
						count: 0
					},
					{
						date: '1',
						count: 0
					},
					{
						date: '1',
						count: 0
					},
					{
						date: '1',
						count: 0
					}
				];

				this.Scrolllist = [];

				this.usersa.timeLength = 0;

				this.usersa.ui_realName = '暂无学生信息';
				this.usersa.ui_joyNumber = '';

				this.ability = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
				this.Comprehensive.forEach(item => {
					item.value = 0;
				});
				this.getusercharts();

				this.traintimer = [0, 0, 0, 0, 0];
				this.settimercensus();

				this.usersa.cla_name = this.options.filter(item => item.cla_guid == this.value)[0].cla_name;
				// 实训成绩信息
				this.setscoreschars();
				return;
			}

			this.getusers();
			this.getstudeleng();
			// this.getstudentereslist();
			this.getcompersta();
			this.generateRandomNumberGreaterThanLast();
			// this.getmyprosta();
			this.taskscoces();

			this.getusertable();
		},
		// 获取班级信息
		getclassinfo() {
			GetClassInfoList(this.siguids).then(res => {
				this.options = res.data.data;
				if (this.$route.query.cla_guid == null) {
					this.value = res.data.data[0].cla_guid;
				} else {
					this.value = this.$route.query.cla_guid;
				}

				this.getstudents();
			});
		},
		getstudents(num) {
			let students = {
				si_guid: this.siguids,
				cla_guid: this.value
			};
			GetStudentInfoList(students).then(async res => {
				// console.log(res,"学生列表")
				if (res.data.data.length == 0) {
					this.siguidvalue = '';
					this.selectuser();
					return;
				}

				this.options1 = res.data.data;
				if (this.$route.query.ui_guid == null || num == 1) {
					this.siguidvalue = res.data.data[0].ui_guid;
				} else {
					this.siguidvalue = this.$route.query.ui_guid ?? localStorage.getItem('uiguid');
				}
				this.selectuser();
			});
		},
		// 获取学员
		async getusers() {
			let isdatascheck1 = await GetDatasyncApi(this.siguidvalue);
			this.isdatascheck = isdatascheck1.data.data;
			this.timera1 = setInterval(async () => {
				let isdatasync = await GetDatasyncApi(this.siguidvalue);
				// console.log(isdatasync.data.data != this.isdatascheck, '获取更新值');
				if (isdatasync.data.data != this.isdatascheck) {
					this.isdatascheck = isdatasync.data.data;
					this.getstudeleng();
					// this.getstudentereslist();
					this.getcompersta();
					this.generateRandomNumberGreaterThanLast();
					// this.getmyprosta();
					this.taskscoces();

					this.getusertable();
				}
			}, 8000);
			GetStudentInfo(this.siguidvalue).then(res => {
				this.usersa = res.data.data;
			});
		},
		// 实训数据报表
		getusertable() {
			this.Scrolllist = [];
			let usertable = {
				ui_guid: this.siguidvalue,
				pageIndex: this.pageindex,
				sx_te_guid: this.testuids
			};
			// GetMyTrainDataSTANewApi(usertable).then(res => {
			GetMyTrainDataSTANewCQApi(usertable).then(res => {
				// console.log(res.data.data, '实训数据报表');
				res.data.data.forEach(item => {
					if (item.projectName != '双流制AS列车无牵引故障') {
						item.projectAST = Math.ceil(this.fullClose(1, 100));
						item.projectBest = Math.ceil(this.fullClose(1, 10));
						item.projectGood = Math.ceil(this.fullClose(1, 10));
						item.projectGeneral = Math.ceil(this.fullClose(1, 10));
						item.projectNoEvaluating = Math.ceil(this.fullClose(1, 10));
					}
				});
				this.Scrolllist = res.data.data.sort(this.sortBy('projectAST', -1));
				let namelist = [];
				let datalist = [];
				this.Scrolllist.forEach(item => {
					namelist.push(item.projectName);
					datalist.push(item.projectAST);
				});
				this.setscoreschars(namelist, datalist);

				this.traindatastalist = [];
				this.traindatastalista = [];
			});
		},
		// 排序
		sortBy(attr, rev) {
			if (rev == undefined) {
				rev = 1;
			} else {
				rev ? 1 : -1;
			}
			return function(a, b) {
				a = a[attr];
				b = b[attr];
				if (a < b) {
					return rev * -1;
				}
				if (a > b) {
					return rev * 1;
				}
				return 0;
			};
		},
		// 去重
		unique(arr) {
			const res = new Map();
			return arr.filter(a => !res.has(a.projectName) && res.set(a.projectName, 1));
		},
		callbackgr() {
			this.$router.back();
		},
		// 综合能力评估
		getcompersta() {
			GetMyComprehensiveSTAPi({
				ui_guid: this.siguidvalue,
				sx_te_guid: this.testuids
			}).then(res => {
				// console.log('能力分析', res.data);

				this.ability = [];
				this.Comprehensive = res.data.data.list;
				if (res.data.data.list.length == 0) {
					this.ability = [];

					this.Comprehensive = [];
				} else {
					res.data.data.list.forEach(item => {
						this.ability.push(item.projecScore);
						item.name = item.projectName;
						item.value = item.projecScore;
					});
					let mathmax = Math.max(...this.ability);
					// let Comprehensive = []
					this.Comprehensive.forEach(item => {
						item.max = mathmax + 10;
						item.text = item.name;
					});
				}
				// console.log(this.Comprehensive,"综合实训技能")
				this.getusercharts();
			});
		},
		getusercharts() {
			let data = [50, 40, 60, 30, 20];
			for (var i = 0; i < data.length; ++i) {
				if (Math.random() > 0.9) {
					data[i] += Math.round(Math.random() * 10);
				} else {
					data[i] += Math.round(Math.random() * 2);
				}
			}

			let option = {
				color: ['#FFE434', '#FFE434', '#56A3F1', '#FF917C'],
				title: {
					text: '综合实训技能',
					left: '4%',
					top: '1%',
					textStyle: {
						color: '#fff',
						fontSize: 22,
						fontWeight: 500
					}
				},
				tooltip: {
					trigger: 'axis'
				},
				radar: [
					{
						indicator: [
							{ text: '标准化作业', max: 100 },
							{ text: '突发事件', max: 100 },
							{ text: '非正常行车', max: 100 },
							{ text: '应急救援', max: 100 },
							{ text: '故障处理', max: 100 }
						],
						radius: '80%',
						center: ['50%', '60%'],
						// 坐标系起始角度，也就是第一个指示器轴的角度。[ default: 90 ]
						name: {
							// (圆外的标签)雷达图每个指示器名称的配置项。
							formatter: '{value}',
							textStyle: {
								fontSize: 16,
								color: '#fff'
							}
						},
						splitArea: {
							//设置图表颜色，show的值为true
							show: true,
							areaStyle: {
								// color:"#c1ddf8", //一般设置方式
								//设置渐变背景色 new echarts.graphic.LinearGradient(a,b,c,d,arr)
								//a ,b,c,d值可为0，1 a:1表示arr中的颜色右到左；c:1 arr中的颜色左到右
								//b:1表示arr中的颜色下到上；d:1表示arr中的颜色上到下
								color: new this.$echarts.graphic.LinearGradient(
									1,
									1,
									1,
									0,
									[
										{ offset: 0, color: '#c1ddf8' }, // 0% 处的颜色
										{ offset: 0.5, color: '#1e83e4' }, // 0% 处的颜色
										{ offset: 0.85, color: '#1e83e4' }, // 0% 处的颜色
										{ offset: 1, color: '#1e83e4' } // 100% 处的颜色
									],
									false
								)
							}
						},
						nameGap: 15
					}
				],
				series: [
					{
						type: 'radar',
						tooltip: {
							trigger: 'item'
						},
						areaStyle: {},
						data: [
							{
								value: data,
								name: '综合能力评估',
								itemStyle: {
									//该数值区域样式设置
									normal: {
										color: 'rgba(255,145,124,.6)', //背景颜色，还需设置areaStyle
										lineStyle: {
											color: 'rgba(255,145,124,.6)' //边框颜色
										}
									}
								},
								label: {
									//显示value中具体的数值
									normal: {
										show: true,
										textStyle: {
											//更改数值样式
											color: '#FFE434',
											fontSize: 16,
											fontWeight: 700
										}
									}
								},
								areaStyle: {
									//设置区域背景颜色透明度
									normal: {
										width: 1,
										opacity: 0.8
									}
								}
							}
						]
					}
				]
			};

			this.option1s = option;
			let myCharts1 = this.$echarts.getInstanceByDom(document.getElementById('usermitemchats'));
			if (myCharts1 == null) {
				myCharts1 = this.$echarts.init(document.getElementById('usermitemchats'));
			}
			myCharts1.setOption(this.option1s);
		},
		// 获取实训时长统计信息
		getstudeleng() {
			// GetStudentTimeLength(this.siguidvalue).then(res => {
			GetStudentTimeLengthApi({
				ui_guid: this.siguidvalue,
				sx_te_guid: this.testuids
			}).then(res => {
				// console.log(res.data.data,'获取实训时长统计信息')
				let traintimer = [];
				if (res.data.data.length == 0) {
					traintimer = [0, 0, 0, 0];
				} else {
					res.data.data.forEach(item => {
						traintimer.push(item.count);
					});
				}

				this.traintimer = traintimer;
				this.settimercensus();
			});
		},
		// 累加数组
		sum(arr) {
			return eval(arr.join('+'));
		},
		settimercensus() {
			// console.log(this.traintimer)
			let data = [10, 53, 45, 12, 12];
			for (var i = 0; i < data.length; ++i) {
				if (Math.random() > 0.9) {
					data[i] += Math.round(Math.random() * 100);
				} else {
					data[i] += Math.round(Math.random() * 20);
				}
			}
			// 列表信息
			this.timeLength = this.sum(data);
			console.log(this.timeLength, '实训时长');
			let options = {
				title: {
					text: '实训时长统计',
					textStyle: {
						color: '#fff',
						fontSize: 22,
						fontWeight: 500
					},
					top: '0%',
					left: '5%'
				},
				grid: {
					top: '20%',
					left: '2%',
					right: '2%',
					bottom: '0%',
					containLabel: true
				},
				xAxis: {
					type: 'category',
					data: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
					axisLabel: {
						show: true,
						textStyle: {
							color: '#FADB71'
						}
					}
				},
				yAxis: {
					type: 'value',
					name: '单位: 小时', //  你的单位写在这就可以
					nameTextStyle: {
						//  单位样式
						color: '#FADB71', //  字体颜色
						fontSize: 14 //  字体大小
					},
					axisLabel: {
						show: true,
						textStyle: {
							color: '#FADB71'
						}
					},
					splitLine: {
						//网格线
						lineStyle: {
							type: 'dashed' //设置网格线类型 dotted：虚线 solid:实线
						},
						show: true //隐藏或显示
					}
				},

				series: [
					{
						label: {
							//数值显示
							show: true, //显示柱状图上每一列的数值
							rotate: 60, //让显示的数值进行旋转
							textStyle: {
								fontSize: 14
							},
							position: 'inside', //标签的位置
							color: '#1c0803'
						},
						// data: this.traintimer,
						data: data,
						type: 'bar',
						color: '#FADB71',
						emphasis: {
							focus: 'series', // 在高亮图形时，是否淡出其它数据的图形已达到聚焦的效果。默认值'none'不淡出其它图形，series' 聚焦当前高亮的数据所在的系列的所有图形，'self' 只聚焦（不淡出）当前高亮的数据的图形
							label: {
								show: true
							}
						}
					}
				]
			};

			this.options4s = options;

			let myCharts4 = this.$echarts.getInstanceByDom(document.getElementById('timercensus'));
			if (myCharts4 == null) {
				myCharts4 = this.$echarts.init(document.getElementById('timercensus'));
			}
			myCharts4.setOption(this.options4s);
		},
		// 任务完成度
		getmyprosta() {
			// GetMyProjectSTA(this.siguidvalue).then(res => {
			GetMyProjectSTANewApi({
				ui_guid: this.siguidvalue,
				sx_te_guid: this.testuids
			}).then(res => {
				// console.log(res.data.data, '实训项目分类统计');
				this.projectsta = res.data.data;

				if (this.projectsta.length > 0) {
					let projectsta = [];
					let projectstabname = [];
					this.projectsta.forEach(item => {
						item.name = item.projectName;
						item.value = item.timeSQT;
						projectsta.push(item.timeSQT);
						projectstabname.push(item.projectName);
					});
					// console.log(this.projectstabname, this.projectstab, '获取list');
					this.projectstabname = projectstabname;
					this.projectstab = projectsta;
				}
			});
		},

		setcensuschats() {
			// // 				animation: true,
			// console.log(document.getElementById('censuscharts'), '获取dom信息');
			// // 部署任务完成度
			// this.option3s = option;
			// let myCharts3 = this.$echarts.getInstanceByDom(document.getElementById('censuscharts'));
			// if (myCharts3 == null) {
			// 	myCharts3 = this.$echarts.init(document.getElementById('censuscharts'));
			// }
			// myCharts3.clear();
			// myCharts3.setOption(option);
			// myCharts3.resize();
		},
		// 实训成绩列表
		getstudentereslist() {
			let resltdata = {
				ui_guid: this.siguidvalue,
				type: this.datenows,
				sx_te_guid: this.testuids
			};
			TrainingTaskStatisticsApi(resltdata).then(res => {
				// console.log(res.data.data, '成绩分析内容');
				if (res.data.data.length > 0) {
					this.scoreschars = [];
					let namelist = [];
					let datalist = [];
					res.data.data.forEach(item => {
						namelist.push(item.ANI_TrainingName);
						datalist.push(item.Score);
					});
					this.setscoreschars(namelist, datalist);
				} else {
					this.setscoreschars();
				}
			});
		},

		setscoreschars(namelist = [], datalist = []) {
			let myCharts2 = this.$echarts.getInstanceByDom(document.getElementById('scores'));
			if (myCharts2 == null) {
				myCharts2 = this.$echarts.init(document.getElementById('scores'));
			}
			if (namelist.length == 0) {
				namelist = [
					'出退勤及交接班作业',
					'列车整备作业',
					'列车出入段作业',
					'列车调车|调试|洗车作业',
					'正线驾驶作业',
					'电话闭塞行车',
					'暴雨天气行车',
					'地震行车',
					'反向行车',
					'救援连挂作业',
					'车站乘客坠轨应急处置',
					'列车打滑应急处置',
					'乘客滞留车门与站台门之间应急处置',
					'正线及车场挤岔应急处置',
					'列车前挡风玻璃破裂应急处置',
					'双流制As列车跨线作业',
					'双流制As列车牵引系统故障应急处理',
					'双流制As列车制动系统故障应急处理',
					'双流制As列车车门故障应急处理',
					'双流制列车遇接触网挂异物应急处置',
					'双流制列车车门夹人夹物突发应急处置',
					'双流制As列车运行遇火灾应急处置'
				];
			}
			if (datalist.length == 0) {
				datalist = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
			}

			let dataAxis = namelist;

			let data = datalist;

			let yMax = 500;
			let dataShadow = [];
			for (let i = 0; i < data.length; i++) {
				dataShadow.push(yMax);
			}
			let option = {
				title: {
					text: '实训成绩',
					left: '4%',
					top: '1%',
					textStyle: {
						color: '#fff',
						fontSize: 22,
						fontWeight: 500
					}
				},
				tooltip: {
					trigger: 'axis'
				},
				grid: {
					bottom: '10%',
					left: '0%',
					right: '2%',
					containLabel: true
				},
				dataZoom: [
					{
						type: 'slider',
						show: true,
						start: 0,
						end: 30,
						bottom: '10',
						realtime: true, //拖动时，是否实时更新系列的视图
						xAxisIndex: [0],
						textStyle: false,
						backgroundColor: '#EDF0F5',
						handleSize: 10,
						handleIcon:
							'image://data:image/png;base64,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',
						dataBackground: {
							lineStyle: {
								opacity: 0
							},
							areaStyle: {
								opacity: 0
							}
						},
						selectedDataBackground: {
							lineStyle: {
								opacity: 0
							},
							areaStyle: {
								opacity: 0
							},
							brushStyle: {
								borderColor: '#f00'
							}
						},
						height: 6,
						fillerColor: ' #2378f7'
					}
				],
				xAxis: {
					data: dataAxis,
					axisLabel: {
						inside: true,
						color: '#fff',
						textStyle: {
							fontSize: 14
						},
						//  让x轴文字方向为竖向
						interval: 0,
						formatter: function(value) {
							return value.split('').join('\n');
						}
					},
					axisTick: {
						show: false
					},
					axisLine: {
						show: false
					},

					z: 10
				},
				yAxis: {
					axisLine: {
						show: false
					},
					axisTick: {
						show: false
					},
					axisLabel: {
						color: '#fff',
						fontSize: 16
					}
				},
				color: ['#5b9bd5', '#ed7d31', '#a5a5a5', '#ffc000', '#4472c4', '#70ad47'],
				series: [
					{
						type: 'bar',
						large: true,
						showBackground: true,
						itemStyle: {
							color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
								{ offset: 0, color: '#83bff6' },
								{ offset: 0.5, color: '#188df0' },
								{ offset: 1, color: '#188df0' }
							])
						},
						emphasis: {
							itemStyle: {
								color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [
									{ offset: 0, color: '#2378f7' },
									{ offset: 0.7, color: '#2378f7' },
									{ offset: 1, color: '#83bff6' }
								])
							}
						},
						data: data
					}
				]
			};
			// Enable data zoom when user click bar.
			const zoomSize = 2;

			this.option2s = option;

			myCharts2.on('click', function(params) {
				// console.log(dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)]);
				myCharts2.dispatchAction({
					type: 'dataZoom',
					startValue: dataAxis[Math.max(params.dataIndex - zoomSize / 2, 0)],
					endValue: dataAxis[Math.min(params.dataIndex + zoomSize / 2, data.length - 1)]
				});
			});

			// console.log(this.option2s, '获取请求');
			myCharts2.setOption(this.option2s);
		}
	},
	components: {
		sacleBox,
		vueSeamlessScroll
	}
};
</script>

<style>
.theme-teal {
	background-color: #142131 !important;
}
</style>

<style scoped lang="less">
// .titlebox {
// 	width: 100%;
// 	position: relative;
// 	.titletr {
// 		width: 100%;
// 	}
// }
.tablesbox {
	display: flex;
	align-content: center;
	width: 100%;

	.tablesboxtr {
		display: flex;
		flex-direction: column;
		align-items: center;
		.biltysbox {
			color: #fff;
			border: 1px solid #fff;
			background: #04428e;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 16px;
			box-sizing: border-box;
		}
		p {
			font-size: 16px;
			width: 100%;
			height: 100%;
			color: #fff;
			border: 1px solid #fff;
			background: #04428e;
			display: flex;
			align-items: center;
			justify-content: center;
			box-sizing: border-box;
		}

		.biltysboxvontent {
			display: flex;
			box-sizing: border-box;
			width: 100%;
		}
	}

	.tablesboxtrend {
		p {
			border-top: none !important;
		}
		p:first-child {
			border-right: none;
		}
		p:first-child {
			border-right: none;
		}
	}
}

.tdprojectname {
	// width: 60px !important;
	// white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
}

.pagination {
	margin: 10px 0 0 1rem;
	color: #fff;
	font-size: 0.8rem;
	display: flex;
	align-items: center;

	.paginationp {
		margin-right: 20%;
		font-weight: 400;
	}

	/deep/ .el-pagination {
		button {
			padding: 0 20px;
			background: rgba(0, 0, 0, 0);
			border: 1px solid #fff;
			color: #fff;
		}

		li {
			background: rgba(0, 0, 0, 0);
			border: 1px solid #fff;
			color: #fff;
		}
	}
}

.taablessc::-webkit-scrollbar {
	display: none;
}

.taablessc::-webkit-scrollbar {
	/*滚动条整体样式*/
	width: 4px;
	/*高宽分别对应横竖滚动条的尺寸*/
	height: 1px;
}

.taablessc::-webkit-scrollbar-thumb {
	/*滚动条里面小方块*/
	border-radius: 10px;
	box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
	background: #78b4b4;
}

.taablessc::-webkit-scrollbar-track {
	/*滚动条里面轨道*/
	box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
	border-radius: 10px;
	background: #ededed;
}

.tables {
	width: 100%;
	height: 100%;
	color: #fff;
	font-size: 1rem;
	position: relative;
	// text-align: center;

	.titletr {
		text-align: center;
		td {
			border-bottom: 1px solid #fff;
		}

		th {
			border: 1px solid #fff;
		}
	}

	tr {
		height: 20px;
		// text-align: center;
	}

	tr td:first-child {
		text-align: center;
	}

	th {
		border: 1px solid #fff;
		height: 20px;
		text-align: center;
	}

	td {
		border: 1px solid #fff;
		height: 20px;
		// text-align: center;
		width: 60px;
	}
}

.datechoice {
	display: flex;
	align-items: center;
	position: absolute;
	top: 8%;
	right: 5%;
	color: #fff;
	width: 20%;
	font-size: 1rem;
	justify-content: space-between;
	cursor: pointer;
}

.dateactives {
	color: #84f602;
}

.usermessages {
	padding: 20px;
	width: 100%;
	height: 45%;
	box-sizing: border-box;
	display: flex;
	align-items: center;
	justify-content: flex-start;

	.usermessagelist {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		height: 100%;
	}

	.usermitem {
		width: 15%;
		height: 100%;
		// display: flex;
		// flex-direction: column;
		position: relative;
		overflow: hidden;
		box-sizing: border-box;

		.usermitems {
			position: relative;

			.usermitestect {
				height: 64%;
				display: flex;
				align-items: center;
				justify-content: flex-start;
				transform: translate(25px, 10px);

				/deep/ .el-select {
					width: 100%;

					.el-input__inner {
						background-color: rgba(255, 255, 255, 0);
						// border: 3px solid #fff;
						color: #fff !important;
						font-size: 1.2rem;
						padding: 20px;
					}
				}
			}

			.sctends {
				display: flex;
				align-items: center;
				justify-content: center;
			}

			.bordertop {
				width: 175px;
				height: 60px;
				position: absolute;
			}

			.borderbottom {
				width: 60px;
				height: 150px;
				position: absolute;
				bottom: 0;
				right: 0%;
			}
		}

		.usermename {
			display: flex;
			flex-direction: column;
			align-items: flex-start;
			width: 65%;
		}

		.usermesbox {
			width: 90%;
			height: 28%;
			margin: 0 auto;
			background-color: #d9523f;
			padding: 0 1rem;
			box-sizing: border-box;
			display: flex;
			align-items: center;
			justify-content: flex-start;
			border-radius: 2px;
			overflow: hidden;

			p {
				color: #fff;
				font-size: 1.2rem;
			}
		}

		.usermesbox:first-child {
			margin-top: 20px;
		}

		.usermesbox:last-child {
			margin-bottom: 20px;
		}

		.bordertop {
			width: 175px;
			height: 60px;
			position: absolute;
		}

		.borderbottom {
			width: 60px;
			height: 170px;
			position: absolute;
			bottom: 0;
			right: 0%;
		}
	}
}

.usertitles {
	display: flex;
	align-items: flex-start;
	justify-content: space-between;
	height: 10%;
	position: relative;

	.userimg {
		width: 90vw;
		height: 100%;
		height: 10vh;
	}

	.usertiefonts {
		font-size: 3rem;
		position: absolute;
		left: 5.5%;
		top: 10%;
		color: #fff;
	}

	.userback {
		width: 20%;
		height: 100%;
		box-sizing: border-box;
		background-color: #04428e;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;

		span {
			font-size: 2rem;
			color: #fff;
		}
	}
}

.appconten {
	background: url('../../images/datetolines.png') no-repeat center;
	// background-size: 100% auto;
	width: 100%;
	height: 100%;
	background-size: 100% 100%;
	// height: 1080px;
	box-sizing: border-box;
	overflow: hidden;
}

.paginationno {
	width: 97%;
	margin: 0 auto;
	height: 40%;
	display: flex;
	justify-content: center;
	align-items: center;
	font-size: 26px;
}

#table .titletrnode {
	border: 1px solid #fff !important;
}

#table .titletdnum {
	border: 1px solid #fff !important;
}

#table tr {
	border: 1px solid #fff !important;
}
#table td {
	border: 1px solid #fff !important;
}

.cilprogess {
	height: 100%;
	padding: 1rem;
	p {
		font-family: 'Arial Normal', 'Arial', sans-serif;
		font-weight: 400;
		font-style: normal;
		font-size: 22px;
		margin-top: 10px;
		letter-spacing: normal;
		color: #fff;
		vertical-align: none;
		text-align: center;
		line-height: normal;
		text-transform: none;
	}
}

/deep/ .el-progress__text {
	font-size: 18px !important;
}

.trainsb {
	height: 90%;
	overflow: hidden;
}

.trainsb ul {
	width: 100%;
	// height: 100%;
	// max-height: 310px;
	// overflow: hidden;
	overflow-y: scroll;
}

.trainsb ul li span {
	margin-right: 10px;
}

.trainsb ul li:nth-of-type(1) p:first-child {
	background-color: #ed405d;
	padding: 10px;
}

.trainsb ul li:nth-of-type(2) p:first-child {
	background-color: #f78c44;
	padding: 10px;
}

.trainsb ul li:nth-of-type(3) p:first-child {
	background-color: #49bcf7;
	padding: 10px;
}

// .trainsb ul li:first-child {
// 	border-bottom: 1px solid #fff;
// }

.trainsb ul::-webkit-scrollbar {
	display: none;
}

.trainsb ul li {
	display: flex;
	width: 100%;
	margin: 10px 0;
	line-height: 35px;
	height: 35px;
	/* border: 1px solid #0E94EA; */
}

.trainsb ul li p {
	color: #fff;
	border-bottom: 0;
	font-size: 1rem;
}

.trainsb ul li p:first-child {
	width: 35px;
	height: 35px;
	background-color: #878787;
	display: flex;
	align-items: center;
	justify-content: center;
}

.trainsb ul li p img {
	width: 30px;
	height: 30px;
	vertical-align: middle;
}
</style>
